import React, { useEffect, useState, useContext, useCallback } from 'react'
import { domainService } from '../../lib/services'
import { AuthContext } from './AuthContext'

const DomainContext = React.createContext({
    companies: [],
    domains: [],
    loading: false,
})

const DomainProvider = ({ children }) => {
    const [domainInfo, setDomainInfo] = useState({
        companies: [],
        domains: [],
    })
    const [loading, setLoading] = useState(false)
    const { user } = useContext(AuthContext)

    const getDomainsInfo = useCallback(async () => {
        if (!user || loading || (domainInfo.companies.length && domainInfo.domains.length)) return

        setLoading(true)
        try {
            const [companies, domains] = await Promise.all([domainService.getCompanies(), domainService.getDomains()])
            setDomainInfo({
                companies: companies?.data || [],
                domains,
            })
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }, [user, loading, domainInfo])

    useEffect(() => {
        let isMounted = true
        if (user && isMounted) getDomainsInfo()

        return () => {
            isMounted = false
        }
    }, [user])

    return <DomainContext.Provider value={{ ...domainInfo, loading }}>{children}</DomainContext.Provider>
}

export { DomainContext, DomainProvider }
